import { CalculationMode } from 'snap-types/src/models/craft/product-options';

import { calculateBatchQuantityPriceAddition } from './batch-quantity';
import { calculateBatchWeightPriceAddition } from './batch-weight';
import { calculateDefaultPriceAddition } from './default-price';
import { calculateLotPriceAddition } from './lot';
import {
  CalculateProductOptionPriceParams,
  CalculateProductOptionPriceResult,
} from './types';

const priceAdditionCalculations: Record<
  CalculationMode,
  (
    params: CalculateProductOptionPriceParams,
  ) => CalculateProductOptionPriceResult
> = {
  [CalculationMode.DEFAULT]: calculateDefaultPriceAddition,
  [CalculationMode.BATCH_QUANTITY]: calculateBatchQuantityPriceAddition,
  [CalculationMode.BATCH_WEIGHT]: calculateBatchWeightPriceAddition,
  [CalculationMode.LOT]: calculateLotPriceAddition,
};

export function calculateProductionOptionPriceAddition(
  params: CalculateProductOptionPriceParams,
): CalculateProductOptionPriceResult {
  const calculate = priceAdditionCalculations[params.option.calculationMode];

  if (!calculate) {
    return {
      isSuccess: false,
      error: 'Unsupported calculation mode',
      calculationMode: params.option.calculationMode,
    };
  }

  return calculate(params);
}
